import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutRoutingModule } from './layout-routing.module';
import { LayoutComponent } from './layout/layout.component';
import { TopbarComponent } from './topbar/topbar.component';
import { FooterComponent } from './footer/footer.component';
import { SharedModule } from '../shared/shared.module';
import {MarketSeoModule} from '@app/market-seo/market-seo.module';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {LocationsEffects} from '@app/marketplace/locations/state/locations-effects';
import {CartEffects} from '@app/marketplace/products/state/shopping-cart/cart-effects';
import {SearchEffects} from '@app/marketplace/products/state/product-search/search-effects';
import {layoutReducer, metaReducers} from '@app/marketplace/storage/storage.reducers';
import {LAYOUT_FEATURE_KEY} from '@app/marketplace/storage/storage.state';
import {IsAuthenticatedDirective} from '@app/directives/is-authenticated.directive';
import {CheckoutMarketGuard} from '@app/guards/chekout.market.guard';
import {ReactiveFormsModule} from '@angular/forms';
import {ContactsEffects} from '@app/marketplace/checkout/state/contacts/contacts-effects';
import { CategoryTreeEffects } from '../categories/state/category-tree/category-tree-effects';
import { SearchComponent } from './search/search.component';
import {AmazonWizardComponent} from '@app/marketplace/layout/search/amazon-wizard/amazon-wizard.component';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {ProductsDetailsEffects} from '@app/marketplace/products/state/product-details/details-effects';
@NgModule({
  declarations: [
    LayoutComponent,
    TopbarComponent,
    SearchComponent,
    FooterComponent,
    IsAuthenticatedDirective,
    AmazonWizardComponent
  ],
  imports: [
    CommonModule,
    MarketSeoModule,
    LayoutRoutingModule,
    StoreModule.forFeature(LAYOUT_FEATURE_KEY, layoutReducer, {metaReducers}),
    EffectsModule.forFeature([LocationsEffects, CartEffects, SearchEffects, CategoryTreeEffects, ContactsEffects, ProductsDetailsEffects]),
    SharedModule,
    ReactiveFormsModule,
    NgbDropdownModule
  ],
    exports: [
        LayoutComponent,
        TopbarComponent,
        SearchComponent,
        FooterComponent,
        IsAuthenticatedDirective
    ],
  providers: [
    CheckoutMarketGuard
  ]
})
export class LayoutModule { }
